// extracted by mini-css-extract-plugin
export const formRow = "ContactForm-module--formRow--oQmN7";
export const formControls = "ContactForm-module--formControls--2_Dhy";
export const submit = "ContactForm-module--submit--1-dgi";